import React from 'react';
import styles from './TrackSelector.module.scss';
import TrackSelectorButton from './TrackSelectorButton';
import { changeTrack } from '../utils';
import useTranslator from '../../../../../hooks/useTranslator';

const TrackSelector = ({ locale = 'en' }) => {

  const translator = useTranslator(locale);
  
  return (
    <div className={styles.trackSelectorContainer}>
      <h2 className={styles.trackSelectorHeader}>
        {translator.mss_welcome_message_portal}
      </h2>
      <div className={styles.trackSelectorButtonRow}>
        <TrackSelectorButton
          onClick={() => {
            changeTrack('behavioral_health');
          }}
          className={styles.trackSelectorButton}
        >
          {translator.bh_picker_home}
        </TrackSelectorButton>
        <TrackSelectorButton
          onClick={() => {
            changeTrack('eap');
          }}
          className={styles.trackSelectorButton}
        >
          {translator.eap_picker_home}
        </TrackSelectorButton>
      </div>
    </div>
  );
};

export default TrackSelector;
